import { apiFetchHelpContent, apiFetchWikiIndex } from '../../../../../../api/help'
import { WikiIndexEntryVM } from '../../sidePanel.model'
import { helpIndexItemsMapperToVM } from './helpPanel.mapper'

export const fetchHelpIndexForSection = async (section: string): Promise<WikiIndexEntryVM[]> => {
  const response = await apiFetchWikiIndex()
  return response ? helpIndexItemsMapperToVM(response, section) : []
}

export const fetchHelpContent = async (path: string): Promise<string> => {
  return await apiFetchHelpContent(path)
}

export const getCurrentPageTitle = (currentSectionPath: string): string => {
  return currentSectionPath.split('/')[2] || ''
}
